import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Socket } from 'ngx-socket-io';
import { ToastrService } from 'ngx-toastr';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-eventcontest',
  templateUrl: './eventcontest.component.html',
  styleUrls: ['./eventcontest.component.scss']
})
export class EventcontestComponent implements OnInit {


  userDetails: any;
  marketId: any;
  ContestList: any = [];
  BetList: any = [];
  selectedRunners: any[] = [];
  selectedSelectionIds: any[] = [];
  session_db: any;
  betloder = false;
  browser_details: any = { browserdetail: '', ipaddress: '' };

  public Base_Url: any;
  option_allow: any

  constructor(private activatdRoute: ActivatedRoute, private route: Router, private socket: Socket, private toastr: ToastrService, public httpClient: UsersService) {
    this.userDetails = JSON.parse(sessionStorage.getItem('userDetails'));
    this.activatdRoute.paramMap.subscribe((param) => {
      this.marketId = param.get("id");
      this.userDetails = JSON.parse(sessionStorage.getItem('userDetails') || '{}');
      if (JSON.parse(sessionStorage.getItem("address_info"))) {
        this.browser_details = JSON.parse(sessionStorage.getItem("address_info"));

      }
    });
  }


  ngOnInit(): void {
    if (this.userDetails?.details?._id) {

      const data = {
        user_id: this.userDetails.details._id,
        marketId: this.marketId
      };
      this.get(data);
      this.selectedRunners = [];
      this.selectedSelectionIds = [];
    }
    this.Base_Url = 'https://adminapi.clubosg.com/uploads/banners/'
    const Data = {
      marketId: this.marketId,
      username: this.userDetails.details
    }
    this.getBets()
  }

  get(data: any): void {
    this.httpClient.SocketPost('get-contest-market', data).subscribe(
      (res: any) => {
        if (res?.response) {
          this.ContestList = res.response;
          this.option_allow = res.response.option_allow
        } else {
          this.ContestList = [];
        }
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }


  getOptionLabel(index: number): string {
    // Converts 0 -> A, 1 -> B, 2 -> C, 3 -> D ...
    return String.fromCharCode(65 + index);
  }

  onRunnerSelect(item: any): void {
    const index = this.selectedSelectionIds.indexOf(item.selectionId);

    if (index === -1) {
      this.selectedRunners.push(item.runnerName);
      this.selectedSelectionIds.push(item.selectionId);
    } else {

      this.selectedRunners.splice(index, 1);
      this.selectedSelectionIds.splice(index, 1);
    }

    // console.log('Selected Runners:', this.selectedRunners);
    // console.log('Selected IDs:', this.selectedSelectionIds);
  }

  submitAnswer() {
    // console.log('this.selectedRunners', this.selectedRunners)
    // console.log('this.selectedRunners.length', this.selectedRunners.length)
    // console.log("option allow", this.option_allow)
    if (!this.selectedRunners.length) {
      this.toastr.error("Please select a runner first!");
      return;
    }
    if (this.selectedRunners.length < this.option_allow) {
      this.toastr.error(`Please select minimum ${this.option_allow} runner(s) first!`);
      return;
    }

    if (this.selectedRunners.length > this.option_allow) {
      this.toastr.error(`Please select  maximum ${this.option_allow} runner(s) first!`);
      return;
    }
    const sessionBet = {
      user: this.userDetails,

      bet: {
        browserdetail: this.browser_details.browserdetail,
        eventId: this.ContestList.eventId,
        eventName: "contest",
        ipaddress: this.browser_details.ipaddress,
        marketId: this.ContestList.marketId,
        marketName: this.ContestList.marketName,
        marketType: "MATCH_ODDS",
        // eventTypeId: "3902",
        // runnerName: this.selectedRunner,
        rate: 0,
        runnerId: this.selectedSelectionIds.join(','),
        selectionName: this.selectedRunners.join(','),
        stake: 0,
        type: "Back"
      }
    };

    this.session_db = sessionBet;
    this.createBetContest(this.session_db);
  }
  createBetContest(data: any) {
    // console.log("Create Bet Contest Data:", data);
    this.socket.emit("create-bet-contest", data);
    this.socket.on("place-bet-contest-success", (res: any) => {
      this.toastr.success(res.message);
      this.selectedRunners = []
      this.selectedSelectionIds = []
      this.socket.removeListener("place-bet-contest-success");
      this.getBets()
    });
    this.socket.on("place-bet-contest-error", (err: any) => {
      this.toastr.error(err.message);
      this.socket.removeListener("place-bet-contest-error");
      this.socket.removeListener("place-bet-contest-success");
    });
  }


  getBets(): void {
    const data = {
      marketId: this.marketId,
      username: this.userDetails.details?.username
    }
    this.httpClient.SocketPost('get-contest-bets', data).subscribe(
      (res: any) => {
        if (res?.response) {
          this.BetList = res.response;
        } else {
          this.BetList = [];
        }
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }



}
